import { render, staticRenderFns } from "./CompetitionInstructionsDialog.vue?vue&type=template&id=3eeb0a9b"
import script from "./CompetitionInstructionsDialog.vue?vue&type=script&lang=js"
export * from "./CompetitionInstructionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports